/*
    homapage chart
*/
import Chartist from 'chartist';
import appear from './appear';

export default class ChartRules {
    constructor(data, group_id = 0, period_id = 0) {
        //start params
        this.data = data;
        this.g = group_id;
        this.p = period_id;
        this.data_g = data[ group_id ];
        this.data_p = data[ group_id ].times[ period_id ];

        //init
        this.init();
    }

    init() {
        if( !document.querySelector("#chart01") ) return;
        this.selectGroup();          
    }

    selectGroup() {
        // устанавливаем триггер группы
        document.querySelector('.test .js-group .drop-menu--trigger').innerHTML = this.data_g.name;
        this.createTimeDrops();

        this.createChart();
        this.selectPeriod();
        this.triggerPeriod();
        this.triggerGroup();
    }
    selectPeriod(){
        var w_width = document.documentElement.clientWidth;
        var stroke = 10;
        if(w_width < 1660){
            stroke = 7;
        }


        document.querySelector('.test .js-time .drop-menu--trigger').innerHTML = this.data_p.title;
        var cr = this.data_p.pers_part_niz;
        this.setNums();
        //круг
        var chartRound = new Chartist.Pie('.ct-chart-round', {
          series: [cr]
        }, {
          donut: true,
          donutWidth: stroke,
          startAngle: 0,
          total: 100,
          showLabel: false
        });

        chartRound.on('draw', function(data) {
          if(data.type === 'slice') {
            // Get the total path length in order to use for dash array animation
            var pathLength = data.element._node.getTotalLength();

            // Set a dasharray that matches the path length as prerequisite to animate dashoffset
            data.element.attr({
              'stroke-dasharray': pathLength + 'px ' + pathLength + 'px'
            });

            // Create animation definition while also assigning an ID to the animation for later sync usage
            var animationDefinition = {
              'stroke-dashoffset': {
                id: 'anim' + data.index,
                dur: 5000,
                from: -pathLength + 'px',
                to:  '0px',
                easing: Chartist.Svg.Easing.easeOutQuint,
                // We need to use `fill: 'freeze'` otherwise our animation will fall back to initial (not visible)
                fill: 'freeze'
              }
            };

            // If this was not the first slice, we need to time the animation so that it uses the end sync event of the previous animation
            if(data.index !== 0) {
              animationDefinition['stroke-dashoffset'].begin = 'anim' + (data.index - 1) + '.end';
            }

            // We need to set an initial value before the animation starts as we are not in guided mode which would do that for us
            data.element.attr({
              'stroke-dashoffset': -pathLength + 'px'
            });

            // We can't use guided mode as the animations need to rely on setting begin manually
            // See http://gionkunz.github.io/chartist-js/api-documentation.html#chartistsvg-function-animate
            data.element.animate(animationDefinition, false);
          }
        });

        new appear('#chart02', chartRound);
    }
    selectChartNav(){
        var navs = document.querySelectorAll('.test .js-chart-nav .chart-nav--item');
        var hovs = document.querySelectorAll('.test .js-chart-hov .chart-hover--item');
        //console.log(this.p);
        for(let n of navs){
            n.classList.remove('active');
        }
        for(let n of hovs){
            n.classList.remove('active');
            n.addEventListener('click', e => {
                var index = Array.prototype.slice.call(n.parentElement.children).indexOf(n)
                this.updateData( this.g, index );
                this.selectPeriod();
                this.selectChartNav();
            });
        }
        navs[ this.p ].classList.add('active');
        hovs[ this.p ].classList.add('active');
    }

    createTimeDrops(){
        document.querySelector('.test .js-time .drop-menu--drop').innerHTML = '';
        for(let t of this.data_g.times){
            document.querySelector('.test .js-time .drop-menu--drop').innerHTML += "<div class='drop-menu--item'>" + t.title + "</div>";
        }
    }

    createChart(){
        this.createChartNavHov();
        var p = this.p;
        // график
        // All you need to do is pass your configuration as third parameter to the chart function
        var data = {
          series: [this.data_g.cart.data]
        };
        var options = {
          fullWidth: true,
          low: 0,
          showArea: true,
          axisY: {
            showGrid: false,
            showLabel: false,
            offset: 0
          },
          axisX: {
            showGrid: false,
            showLabel: false,
            offset: 0
          },
          chartPadding: {
            right: 5,
            left: 5,
            bottom: 0,
          }
        };

        var chartLine = new Chartist.Line('#chart01', data, options);

        chartLine.on('created', function(data) {
            var i = document.querySelectorAll('.ct-point');
            var tooltip = document.querySelectorAll('.js-chart-tooltip');
            var lines = document.querySelectorAll('.ct-point-line');
            var x, y;
            if(i) {
                var index = 0;
                for(let el of i) {
                    x = el.getAttribute('x1');
                    y = el.getAttribute('y1');
                    tooltip[index].style.left = x+"px";
                    tooltip[index].style.top = y+"px";


                    index++;
                }
            }

            //lines[p].classList.add('active');
        });
    }

    createChartNavHov(){
        document.querySelector('.test .js-chart-nav').innerHTML = '';
        document.querySelector('.test .js-chart-hov').innerHTML = '';
        for(let n of this.data_g.cart.label){
            document.querySelector('.test .js-chart-nav').innerHTML += "<div class='chart-nav--item'>"+n+"</div>";
        }
        for(let h of this.data_g.cart.data){
            document.querySelector('.test .js-chart-hov').innerHTML += "<div class='chart-hover--item js-chart-hover'><div class='tooltip js-chart-tooltip'>"+this.triplets(h)+"</div></div>";
        }
        this.selectChartNav();
    }

    setNums(){
        document.querySelector('.test .js-num_zak').innerHTML = this.triplets(this.data_p.num_zak);
        document.querySelector('.test .js-pers_zak_niz').innerHTML = this.data_p.pers_zak_niz;
        document.querySelector('.test .js-num_zak_niz').innerHTML = this.triplets(this.data_p.num_zak_niz);
        document.querySelector('.test .js-num_trend').innerHTML = this.triplets(this.data_p.num_trend.v);
        document.querySelector('.test .js-pers_part_niz').innerHTML = this.data_p.pers_part_niz;
        document.querySelector('.test .js-num_val').innerHTML = this.triplets(this.data_p.num_val);
        document.querySelector('.test .js-num_niz_zak').innerHTML = this.triplets(this.data_p.num_niz_zak);

        if(this.data_p.num_trend.top){
            document.querySelector('.test .js-num_trend').classList.remove('revers');
        } else {
            document.querySelector('.test .js-num_trend').classList.add('revers');
        }

        document.querySelector('.test .js-pers_zak_niz_line').style.width = (100 - this.data_p.pers_zak_niz) + "%";
    }

    triggerPeriod(){
        var periodTriigers = document.querySelectorAll('.test .js-time .drop-menu--item');
        for(let el of periodTriigers) {
            el.addEventListener('click', e => {
                var index = Array.prototype.slice.call(el.parentElement.children).indexOf(el);
                this.updateData( this.g, index );
                this.selectPeriod();
                this.selectChartNav()
            });
        }
    }

    triggerGroup(){
        var periodTriigers = document.querySelectorAll('.test .js-group .drop-menu--item');
        for(let el of periodTriigers) {
            el.addEventListener('click', e => {
                var index = Array.prototype.slice.call(el.parentElement.children).indexOf(el);
                this.updateData( index, 0 );
                this.selectGroup();
                this.triggerPeriod();
            });
        }
        this.selectPeriod();
        this.triggerPeriod();
    }

    updateData(g, p){
        this.g = g;
        this.p = p;
        this.data_g = this.data[ g ];
        this.data_p = this.data[ g ].times[ p ];
    }

    triplets(str) {
        // \u202f — неразрывный узкий пробел
        return str.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1\u202f');
    }
}